import { render, staticRenderFns } from "./SectionWhoAreWe.vue?vue&type=template&id=a6b64360&"
import script from "./SectionWhoAreWe.vue?vue&type=script&lang=js&"
export * from "./SectionWhoAreWe.vue?vue&type=script&lang=js&"
import style0 from "./SectionWhoAreWe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports